<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>设备管理</el-breadcrumb-item>
      <el-breadcrumb-item>设备管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 查询用户 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.mac" @keyup.enter.native="clicksearch" placeholder="请输入MAC地址" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.cardnumber" @keyup.enter.native="clicksearch" placeholder="请输入保修卡号" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <Rsljigou :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigou"></Rsljigou>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.bomsn" placeholder="请选择" class="select" style="width: 200px;">
              <el-option label="请选择设备类型" value=""></el-option>
              <el-option
                v-for="item in bomSnList" :key="item.Value" :label="item.Label" :value="item.Value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.saletype" placeholder="请选择" class="select" style="width: 200px;">
              <el-option
                v-for="item in saleTypeList" :key="item.Value" :label="item.Label" :value="item.Value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.gujianversion" @keyup.enter.native="clicksearch" placeholder="请输入固件版本号" style="width: 150px;"></el-input>
          </el-form-item>
          <el-date-picker v-if="SubRule_Device_Pause" v-model="keywords.begintime" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" class="mr15"></el-date-picker>
          <el-date-picker v-if="SubRule_Device_Pause" v-model="keywords.endtime" type="date" value-format="yyyy-MM-dd" placeholder="结束时间" class="mr15"></el-date-picker>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
            <el-button type="primary" @click="clickModifyJigouPlLiang" v-if="SubRule_Device_ModifyJigouPlLiang">批量更改归属机构</el-button>
            <el-button type="success" @click="clickexcel" v-if="SubRule_ExcelDevice">导出Excel</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询用户 end -->

        <el-table v-loading="loading" :data="dataList" border stripe >
          <el-table-column prop="Jigouname" label="归属机构" min-width="15%"></el-table-column>
          <el-table-column prop="Batchno" label="批次号" min-width="10%" v-if="SubRule_Device_BatchNo"></el-table-column>
          <el-table-column prop="Mac" label="MAC地址" min-width="10%"></el-table-column>
          <el-table-column prop="Cardnumber" label="保修卡号" min-width="10%"></el-table-column>
          <el-table-column prop="BomsnName" label="设备类型" min-width="8%"></el-table-column>
          <el-table-column prop="SaletypeName" label="销售类型" min-width="8%"></el-table-column>
          <el-table-column prop="Gujianversion" label="固件版本号" min-width="9%"></el-table-column>
          <el-table-column prop="Macfirstusertime" label="首次激活时间" min-width="10%" v-if="SubRule_Device_Pause"></el-table-column>
          <el-table-column prop="Glassusestate" label="是否暂停使用" min-width="10%"></el-table-column>
          <el-table-column label="操作" min-width="20%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="SubRule_Device_Modify" @click="goModifyDeviceInformation(scope.row)">修改</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="SubRule_Device_ModifyJigou" @click="clickModifyJigou(scope.row)">修改归属机构</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="SubRule_Device_Info" @click="goDeviceManagementDetails(scope.row)">查看详情</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="SubRule_Device_Pause" @click="forcedSuspension(scope.row)">强制暂停</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="SubRule_Device_Clear" @click="clearData(scope.row)">清空设备数据(慎重!)</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <!-- 添加设备 start -->
      <el-tab-pane label="添加设备" v-if="SubRule_Device_Add">
        <el-form :model="addDevice" ref="addDeviceRef" label-width="75px">
          <el-form-item label="归属机构" class="addAdminForm">
            <Rsljigou :propsjigouid="addDevice.jigouid" :propsjigouname="addDevice.jigouname" @change="changeRsljigou"></Rsljigou>
          </el-form-item>
          <el-form-item label="批次号" class="addAdminForm">
            <el-input v-model="addDevice.batchno" placeholder="请输入批次号"></el-input>
          </el-form-item>
          <el-form-item label="MAC地址" class="addAdminForm">
            <el-input v-model="addDevice.mac" placeholder="请输入MAC地址"></el-input>
          </el-form-item>
          <el-form-item label="保修卡号" class="addAdminForm">
            <el-input v-model="addDevice.cardnumber" placeholder="请输入保修卡号"></el-input>
          </el-form-item>
          <el-form-item label="设备类型">
            <el-select v-model="addDevice.bomsn" placeholder="请选择" class="select" style="width: 200px;">
              <el-option label="请选择设备类型" value=""></el-option>
              <el-option
                v-for="item in bomSnList" :key="item.Value" :label="item.Label" :value="item.Value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="销售类型">
            <el-select v-model="addDevice.saletype" placeholder="请选择" class="select" style="width: 200px;">
              <el-option
                v-for="item in saleTypeList" :key="item.Value" :label="item.Label" :value="item.Value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="生产商" class="addAdminForm">
            <el-input v-model="addDevice.producename" placeholder="请输入生产商"></el-input>
          </el-form-item>
          <el-form-item label="生产日期" class="addAdminForm">
            <el-date-picker v-model="addDevice.producetime" type="date" placeholder="生产日期" class="select" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>

          <el-form-item class="mt20">
            <el-button type="primary" @click="clickadd">添加</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 添加设备 end -->

      <el-tab-pane label="修改" name="second" disabled="disabled">
        <DeviceManagementModify ref="SubVuesecond" v-on:triggerFunc="BackToFirst"></DeviceManagementModify>
      </el-tab-pane>

      <el-tab-pane label="修改归属机构" name="six" disabled="disabled">
        <DeviceManagementModifyJigou ref="SubVuesix" v-on:triggerFunc="BackToFirst"></DeviceManagementModifyJigou>
      </el-tab-pane>

      <el-tab-pane label="查看详情" name="three" disabled="disabled">
        <DeviceManagementDetails ref="SubVuethree" v-on:triggerFunc="BackToFirst"></DeviceManagementDetails>
      </el-tab-pane>

      <el-tab-pane label="强制暂停" name="four" disabled="disabled">
        <DeviceManagementSuspend ref="SubVuefour" v-on:triggerFunc="BackToFirst"></DeviceManagementSuspend>
      </el-tab-pane>

      <el-tab-pane label="批量修改" name="five" disabled="disabled">
        <DeviceManagementModifyJigouPlLiang ref="SubVuefive" v-on:triggerFunc="BackToFirst"></DeviceManagementModifyJigouPlLiang>
      </el-tab-pane>

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import Rsljigou from '@/components/Rsljigou.vue'
import DeviceManagementModify from '@/componentsSubVue/DeviceManagementModify.vue'
import DeviceManagementModifyJigou from '@/componentsSubVue/DeviceManagementModifyJigou.vue'
import DeviceManagementModifyJigouPlLiang from '@/componentsSubVue/DeviceManagementModifyJigouPlLiang.vue'
import DeviceManagementDetails from '@/componentsSubVue/DeviceManagementDetails.vue'
import DeviceManagementSuspend from '@/componentsSubVue/DeviceManagementSuspend.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    Rsljigou,
    DeviceManagementModify,
    DeviceManagementModifyJigou,
    DeviceManagementModifyJigouPlLiang,
    DeviceManagementDetails,
    DeviceManagementSuspend
  },
  name: 'MyDeviceManagement',
  data () {
    return {
      loading: false,
      activeName: 'first',
      bomSnList: [],
      saleTypeList: [],
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      // 查询客户
      keywords: {
        mac: '',
        cardnumber: '',
        jigouid: '-1',
        jigouname: '',
        bomsn: '',
        saletype: '0',
        gujianversion: '',
        salestatus: '-1',
        begintime: '',
        endtime: ''
      },
      // 添加设备
      addDevice: {
        jigouid: '0',
        jigouname: '',
        batchno: '',
        mac: '',
        cardnumber: '',
        bomsn: '',
        saletype: '0',
        producename: '',
        producetime: ''
      },
      SubRule_Device_Add: false,
      SubRule_ExcelDevice: false,
      SubRule_ExcelImportDevice: false,
      SubRule_Device_Modify: false,
      SubRule_Device_ModifyJigou: false,
      SubRule_Device_ModifyJigouPlLiang: false,
      SubRule_Device_Info: false,
      SubRule_Device_Pause: false,
      SubRule_Device_Clear: false,
      SubRule_Device_BatchNo: false
    }
  },
  mounted () {
    this.apigetDevicenum()
    this.apigetDevicelist()

    var that = this
    Vue.prototype.FunListBomsn(function (response) {
      if (response.data.Code === 200) {
        that.bomSnList = response.data.List
        that.saleTypeList = response.data.ListSaleType
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Device_Add', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Device_Add = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ExcelDevice', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ExcelDevice = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ExcelImportDevice', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ExcelImportDevice = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Device_Modify', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Device_Modify = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Device_ModifyJigou', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Device_ModifyJigou = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Device_ModifyJigouPlLiang', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Device_ModifyJigouPlLiang = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Device_Info', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Device_Info = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Device_Pause', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Device_Pause = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Device_Clear', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Device_Clear = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Device_BatchNo', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Device_BatchNo = true
      }
    })
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
    },
    changeRsljigou (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
      this.addDevice.jigouid = vid
      this.addDevice.jigouname = vname
    },
    clickreturn () {
      this.activeName = 'first'
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apigetDevicelist()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apigetDevicenum()
      this.apigetDevicelist()
    },
    clickadd () {
      this.apiaddDevice()
    },
    clickexcel () {
      this.apiExcelDevice()
    },
    // 修改
    goModifyDeviceInformation (row) {
      this.activeName = 'second'
      this.$refs.SubVuesecond.LoadData({ name: '', params: { glassid: row.Id, Jigouid: row.Jigouid, Jigouname: row.Jigouname, Batchno: row.Batchno, Mac: row.Mac,Cardnumber: row.Cardnumber, Bomsn: row.Bomsn, BomsnName: row.BomsnName, Saletype: row.Saletype, SaletypeName: row.SaletypeName, Producename: row.Producename, Producetime: row.Producetime } })
    },
    // 查看详情
    goDeviceManagementDetails (row) {
      this.activeName = 'three'
      this.$refs.SubVuethree.LoadData({ name: '', params: { glassid: row.Id, Jigouname: row.Jigouname, Mac: row.Mac, Cardnumber: row.Cardnumber, Bomsn: row.Bomsn, BomsnName: row.BomsnName, Saletype: row.Saletype, SaletypeName: row.SaletypeName, Producename: row.Producename, Producetime: row.Producetime, Gujianversion: row.Gujianversion } })
    },
    // 强制暂停
    forcedSuspension (row) {
      this.activeName = 'four'
      this.$refs.SubVuefour.LoadData({ name: '', params: { glassid: row.Id } })
    },
    // 批量更改归属机构
    clickModifyJigouPlLiang () {
      this.activeName = 'five'
      this.$refs.SubVuefive.LoadData({ name: '', params: null })
    },
    // 更改归属机构
    clickModifyJigou (row) {
      this.activeName = 'six'
      this.$refs.SubVuesix.LoadData({ name: '', params: { glassid: row.Id, Jigouid: row.Jigouid, Jigouname: row.Jigouname, Mac: row.Mac, Cardnumber: row.Cardnumber, Bomsn: row.Bomsn, BomsnName: row.BomsnName, Saletype: row.Saletype, SaletypeName: row.SaletypeName, Producename: row.Producename, Producetime: row.Producetime } })
    },
    // 清空设备数据(慎重!)
    clearData (row) {
      this.$confirm('是否清空设备数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiforceClearDevice(row.Id, row.Mac)
      })
    },
    apigetDevicelist: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        mac: that.keywords.mac,
        cardnumber: that.keywords.cardnumber,
        jigouid: that.keywords.jigouid,
        bomsn: that.keywords.bomsn,
        saletype: that.keywords.saletype,
        gujianversion: that.keywords.gujianversion,
        salestatus: that.keywords.salestatus,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetDevicelist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    apigetDevicenum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        mac: that.keywords.mac,
        cardnumber: that.keywords.cardnumber,
        jigouid: that.keywords.jigouid,
        bomsn: that.keywords.bomsn,
        saletype: that.keywords.saletype,
        gujianversion: that.keywords.gujianversion,
        salestatus: that.keywords.salestatus,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetDevicenum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiaddDevice: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        jigouid: that.addDevice.jigouid,
        batchno: that.addDevice.batchno,
        mac: that.addDevice.mac,
        cardnumber: that.addDevice.cardnumber,
        bomsn: that.addDevice.bomsn,
        saletype: that.addDevice.saletype,
        producename: that.addDevice.producename,
        producetime: that.addDevice.producetime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddDevice, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'

            that.addDevice.jigouid = '0'
            that.addDevice.jigouname = ''
            that.addDevice.batchno = ''
            that.addDevice.mac = ''
            that.addDevice.cardnumber = ''
            that.addDevice.bomsn = ''
            that.addDevice.saletype = '0'
            that.addDevice.producename = ''
            that.addDevice.producetime = ''

            that.apigetDevicenum()
            that.apigetDevicelist()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiforceClearDevice: function (glassid, mac) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassid: glassid,
        mac: mac
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ForceClearDevice, Qs.stringify(data))
        .then(function (response) {
          that.apigetDevicenum()
          that.apigetDevicelist()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiExcelDevice: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        mac: that.keywords.mac,
        cardnumber: that.keywords.cardnumber,
        jigouid: that.keywords.jigouid,
        bomsn: that.keywords.bomsn,
        saletype: that.keywords.saletype,
        gujianversion: that.keywords.gujianversion,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelDevice, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.$confirm('是否跳转到文件管理，查看导出情况?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              showCancelButton: true,
              type: 'warning'
            }).then(() => {
              that.$router.push({ path: '/FileManagementExcel' })
            })
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}
</style>
